import { useTranslation } from "react-i18next";
import "./contact.css";
import NewLayout from "../layout/newLayout";
import ContactForm from "./contactForm";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { captchaKey } from "../../config/key";
import Storage from "../../utils/storage";


const ContactUs = () => {
  const { t } = useTranslation();
      const lang = Storage.get("lang")?.shortCode
    ? Storage.get("lang")?.shortCode
    : "he";


  return (
    <NewLayout>
                    <GoogleReCaptchaProvider
            language={lang === "en" ? "en" : "iw"}
            // reCaptchaKey="6Ldlc04qAAAAAGtz64kd9mFGaBBovx0VZU01r5Dt" // for testing
            reCaptchaKey={captchaKey} //hidoc key
          >

      <div className="contact-page">
        <div className="container">
          <div className="contact-title">
            <h2>{t("contact.heading")}</h2>
            <p>{t("contact.paragraph1")}</p>
            <p>{t("contact.paragraph2")}</p>
            <p>
              {t("contact.paragraph3")}{" "}
              <a
                href="mailto:support@hidoc.co.il"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@hidoc.co.il
              </a>
            </p>
          </div>
          <ContactForm />
        </div>
      </div>
      </GoogleReCaptchaProvider>
    </NewLayout>
  );
};

export default ContactUs;
